import { useElements, useStripe } from "@stripe/react-stripe-js";
import type { Stripe } from "@stripe/stripe-js";
import { useCallback } from "react";

import type { StripeElements } from "../StripeElements/types";
import { CheckoutError } from "./CheckoutError";

interface StripeElementsResult {
  stripe: Stripe;
  stripeElements: StripeElements;
}

interface GetStripeElements {
  (caller: string): StripeElementsResult;
}

interface GetStripeElementsOrNull {
  (): StripeElementsResult | null;
}

export const useGetStripeElementsOrNull = () => {
  const stripe = useStripe();
  const stripeElements = useElements();

  return useCallback<GetStripeElementsOrNull>(() => {
    if (!stripeElements || !stripe) {
      return null;
    }
    return {
      stripe,
      stripeElements: stripeElements as StripeElements,
    };
  }, [stripe, stripeElements]);
};

export const useGetStripeElements = () => {
  const stripe = useStripe();
  const stripeElements = useElements();

  return useCallback<GetStripeElements>(
    (caller: string) => {
      if (!stripeElements || !stripe) {
        throw CheckoutError.stripeNotInitialized(caller);
      }
      return {
        stripe,
        stripeElements: stripeElements as StripeElements,
      };
    },
    [stripe, stripeElements],
  );
};
